<template>
  <b-container fluid class="py-4">
    <b-card no-body class="mb-4 shadow-sm rounded-lg">
      <b-card-header class="bg-white border-0 py-3">
        <h3 class="mb-0 font-weight-bold text-dark">Kemaskini Pentadbir</h3>
      </b-card-header>
      <b-card-body class="p-4">
        <b-row>
          <b-col lg="6" class="mb-4">
            <b-form-group label="Nama" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.name }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="mb-4">
            <b-form-group label="No Kad Pengenalan" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.icno }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="mb-4">
            <b-form-group label="Emel" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.email }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="mb-4">
            <b-form-group label="Peranan" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.status_entitle }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-between mt-4">
          <b-button variant="info" class="rounded-pill px-4 py-2" @click="showSearchModal">
            <i class="fas fa-search mr-1"></i> Cari Pengguna
          </b-button>
        </div>
        <!-- Paparan hasil carian -->
        <div v-if="carianPengguna && carianPengguna.name" class="mt-4">
          <b-card class="shadow-sm rounded-lg p-3">
            <p class="mb-2"><strong>Nama:</strong> {{ carianPengguna.name }}</p>
            <p class="mb-2"><strong>Emel:</strong> {{ carianPengguna.email }}</p>
            <p class="mb-2"><strong>{{ isPentadbirAwam ? 'Agensi' : 'Organisasi' }}:</strong> {{
              carianPengguna.ministry }}</p>
            <p class="mb-2"><strong>No Kad Pengenalan:</strong> {{ carianPengguna.nokp }}</p>
          </b-card>
          <b-button variant="success" class="rounded-pill px-4 py-2 mt-3" @click="tambahPengguna">
            <i class="fas fa-save mr-1"></i> Kemaskini
          </b-button>
        </div>
      </b-card-body>
    </b-card>
    <!-- Modal untuk carian pengguna -->
    <b-modal id="searchUserModal" title="Cari Pengguna" hide-footer header-class="bg-white border-0 py-3"
      body-class="p-4">
      <b-form @submit.prevent="cariPengguna">
        <b-form-group label="Cari Berdasarkan No Kad Pengenalan" label-class="font-weight-bold text-muted">
          <b-input-group>
            <b-form-input id="nokp-cari-input" v-model="nokp" placeholder="Masukkan No Kad Pengenalan" maxlength="12"
              type="tel" pattern="[0-9]*" inputmode="numeric" class="rounded-pill no-spinner" @keypress="onlyNumber"
              @input="validateNokp"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" class="rounded-pill ml-2" @click="cariPengguna">
                <i class="fas fa-search mr-1"></i> Cari
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-modal>
  </b-container>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseURL } from '../../../services/baseURL';
export default {
  name: 'AdminUpdate',
  data() {
    return {
      user: {},
      nokp: '',
      carianPengguna: {
        name: null,
        email: null,
        ministry: null,
        nokp: null,
      },
    };
  },
  computed: {
    isPentadbirAwam() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.peranan === 'pentadbir awam';
    },
  },
  methods: {
    onlyNumber($event) {
      const keyCode = $event.keyCode || $event.which;
      const keyValue = String.fromCharCode(keyCode);
      if (/[^0-9]/.test(keyValue)) {
        $event.preventDefault();
      }
    },
    handlePaste(event) {
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/[^0-9]/.test(pastedText)) {
        event.preventDefault();
        Swal.fire({
          title: 'Amaran',
          text: 'Hanya nombor dibenarkan',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      }
    },
    validateNokp() {
      this.nokp = this.nokp.replace(/[^0-9]/g, '').slice(0, 12);
    },
    async getProfile() {
      try {
        const response = await axios.post(
          `${baseURL}/papar_profile.php`,
          { user: { id: this.$route.params.id } },
          { headers: { 'Content-Type': 'application/json' } }
        );
        this.user = response.data[0] || {};
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    },
    showSearchModal() {
      this.nokp = '';
      this.carianPengguna = { name: null, email: null, ministry: null, nokp: null };
      this.$bvModal.show('searchUserModal');
    },
    async cariPengguna() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      const peranan = user.peranan || null;
      const buidagensi = user.buidagensi || null;
      if (this.nokp.length !== 12) {
        Swal.fire({
          title: 'Perhatian',
          text: 'No Kad Pengenalan mesti mengandungi 12 digit',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        return;
      }
      try {
        const response = await axios.get(
          `${baseURL}/cari_pengguna.php?nokp=${this.nokp}&peranan=${encodeURIComponent(peranan)}&buidagensi=${encodeURIComponent(buidagensi)}&icno=${this.user.icno}`
        );
        const data = response.data.data;
        const keputusan = response.data.keputusan;

        if (!response.data.success || !data || data.name === 'Tiada Maklumat Pengguna') {
          this.carianPengguna = { name: null, email: null, ministry: null, nokp: null };
          Swal.fire({
            title: 'Pengguna Tidak Dijumpai',
            text: 'Tiada maklumat pengguna ditemui untuk No Kad Pengenalan yang dimasukkan.',
            icon: 'info',
            confirmButtonText: 'OK',
          });
          return;
        }
        // Validate constraints
        // Check user type and agency only if keputusan is not 'SAMA'
        if (keputusan !== 'SAMA' && (data.user_type !== 'public' || data.agency_id !== buidagensi)) {
          this.carianPengguna = { name: null, email: null, ministry: null, nokp: null };
          Swal.fire({
            title: 'Carian Tidak Berjaya',
            text: 'Tiada maklumat yang sepadan atau capaian tidak dibenarkan. Sila semak dan cuba semula.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
          return;
        }
        // If constraints are met, update carianPengguna
        this.carianPengguna = data;
        Swal.fire({
          title: 'Maklumat Pengguna Ditemui',
          html: `
        <p><strong>Nama:</strong> ${this.carianPengguna.name}</p>
        <p><strong>Emel:</strong> ${this.carianPengguna.email}</p>
        <p><strong>${this.isPentadbirAwam ? 'Agensi' : 'Organisasi'}:</strong> ${this.carianPengguna.ministry}</p>
        <p><strong>No Kad Pengenalan:</strong> ${this.carianPengguna.nokp}</p>
        ${this.carianPengguna.ada_record === 1 ? '<p><strong>Telah ada rekod</strong></p>' : ''}
      `,
          icon: 'success',
          confirmButtonText: 'OK',
        });
        this.$bvModal.hide('searchUserModal');
      } catch (error) {
        console.error('Error:', error);
        Swal.fire({
          title: 'Ralat',
          text: 'Ralat semasa memproses permintaan. Sila cuba lagi.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    async tambahPengguna() {
      const payload = {
        name: this.carianPengguna.name,
        email: this.carianPengguna.email,
        ministry: this.carianPengguna.ministry,
        nokp: this.nokp,
        icno: this.user.icno,
      };
      try {
        const response = await axios.post(`${baseURL}/pindah_pentadbir.php`, payload);
        if (response.data.success == 1) {
          Swal.fire({
            title: 'Berjaya!',
            text: response.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
          });
          this.resetTambahPengguna();
        } else {
          Swal.fire({
            title: 'Tidak Berjaya!',
            text: response.data.message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } catch {
        Swal.fire({
          title: 'Ralat',
          text: 'Ralat pelayan semasa menambah pengguna',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    resetTambahPengguna() {
      this.nokp = '';
      this.carianPengguna = { name: null, email: null, ministry: null, nokp: null };
    },
  },
  created() {
    this.getProfile();
  },
};
</script>
<style scoped>
.card {
  background: #fff;
  border: 1px solid #e9ecef;
}

.card-header {
  background: #f8f9fa;
  color: #343a40;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 2px solid #dee2e6;
  padding: 1rem;
}

.form-control-static {
  font-size: 0.875rem;
  color: #343a40;
  margin-bottom: 0;
}

.text-dark {
  color: #343a40 !important;
}

.text-muted {
  color: #6c757d !important;
}

.btn-primary,
.btn-success,
.btn-info,
.btn-outline-secondary {
  font-size: 0.875rem;
  padding: 0.5rem 1.5rem;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.form-control {
  border: 1px solid #ced4da;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  transition: border-color 0.2s ease;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.1);
}

h3 {
  font-size: 1.5rem;
}

label {
  font-size: 0.875rem;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>
